import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDN-nDhTZShtevyeLaa6jbALCFdbB36zWM",
  authDomain: "boi-gardens.firebaseapp.com",
  projectId: "boi-gardens",
  storageBucket: "boi-gardens.firebasestorage.app",
  messagingSenderId: "723165913640",
  appId: "1:723165913640:web:93d6fbce1480cc38930b1d",
  measurementId: "G-XB6TKW53KC"

};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);